import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { ScheduleCategory } from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    statuses  : [],
    sort      : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "SCHEDULE_CATEGORY_LOADING" });
    },

    /**
     * Fetches the Schedule Category List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await ScheduleCategory.getAll(params);
        data.sort  = params;
        dispatch({ type : "SCHEDULE_CATEGORY_LIST", data });
    },

    /**
     * Fetches a single Schedule Category
     * @param {Function} dispatch
     * @param {Number}   scheduleCategoryID
     * @returns {Promise}
     */
    async fetchElem(dispatch, scheduleCategoryID) {
        const data = await ScheduleCategory.getOne({ scheduleCategoryID });
        dispatch({ type : "SCHEDULE_CATEGORY_ELEM", data });
        return data;
    },

    /**
     * Fetches the Schedule Category Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await ScheduleCategory.getEditData();
        dispatch({ type : "SCHEDULE_CATEGORY_EDIT", data });
    },

    /**
     * Edits/Creates a Schedule Category
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return ScheduleCategory.edit(data);
    },

    /**
     * Deletes the Schedule Category
     * @param {Function} dispatch
     * @param {Number}   scheduleCategoryID
     * @returns {Promise}
     */
    deleteElem(dispatch, scheduleCategoryID) {
        return ScheduleCategory.delete({ scheduleCategoryID });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "SCHEDULE_CATEGORY_LIST", "SCHEDULE_CATEGORY_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "SCHEDULE_CATEGORY_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "SCHEDULE_CATEGORY_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : action.data.list,
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "SCHEDULE_CATEGORY_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : action.data.elem,
            statuses  : action.data.statuses,
        };

    case "SCHEDULE_CATEGORY_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
